export const selectStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "blue" : "",
    backgroundColor: state.isSelected ? "#eee" : "",
    textAlign: "left",
    cursor: "pointer",
  }),
  container: (base, state) => ({
    ...base,
    width: "100%",
    border: state.isFocused ? "none" : "none",
    outline: state.isSelected ? "none" : "none",
  }),
  control: (base, state) => ({
    ...base,
    border: state.isFocused ? "none" : "none",
    outline: state.isSelected ? "none" : "none",
    textAlign: "left",
    cursor: "pointer",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "black",
    padding: 2,
    paddingRight: 6,
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: 0,
    paddingLeft: 2,
  }),
};
